export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAIL = "SIGNIN_FAIL";
export const SIGNIN_TWO_FACTOR_REQUIRED = "SIGNIN_TWO_FACTOR_REQUIRED";
export const CLEAR_TWO_FACTOR_CHALLENGE = "CLEAR_TWO_FACTOR_CHALLENGE";

export const LOGOUT = "LOGOUT";

export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAIL = "REFRESH_TOKEN_FAIL";
export const GET_MOD_PROFILE_SUCCESS = "GET_MOD_PROFILE_SUCCESS";
export const GET_MOD_PROFILE_FAIL = "GET_MOD_PROFILE_FAIL";

export const GET_CONTEXT_AUTH_DATA_SUCCESS = "GET_CONTEXT_AUTH_DATA_SUCCESS";
export const GET_CONTEXT_AUTH_DATA_FAIL = "GET_CONTEXT_AUTH_DATA_FAIL";

export const GET_TRUSTED_AUTH_CONTEXT_DATA_SUCCESS =
  "GET_TRUSTED_AUTH_CONTEXT_DATA_SUCCESS";
export const GET_TRUSTED_AUTH_CONTEXT_DATA_FAIL =
  "GET_TRUSTED_AUTH_CONTEXT_DATA_FAIL";

export const GET_BLOCKED_AUTH_CONTEXT_DATA_SUCCESS =
  "GET_BLOCKED_AUTH_CONTEXT_DATA_SUCCESS";
export const GET_BLOCKED_AUTH_CONTEXT_DATA_FAIL =
  "GET_BLOCKED_AUTH_CONTEXT_DATA_FAIL";

export const DELETE_CONTEXT_AUTH_DATA_FAIL = "DELETE_CONTEXT_AUTH_DATA_FAIL";

export const BLOCK_CONTEXT_AUTH_DATA_FAIL = "BLOCK_CONTEXT_AUTH_DATA_FAIL";

export const UNBLOCK_CONTEXT_AUTH_DATA_FAIL = "UNBLOCK_CONTEXT_AUTH_DATA_FAIL";

export const GET_USER_PREFERENCES_SUCCESS = "GET_USER_PREFERENCES_SUCCESS";
export const GET_USER_PREFERENCES_FAIL = "GET_USER_PREFERENCES_FAIL";

export const ERROR_MESSAGE = "Something went wrong.";
export const SIGNUP_SUCCESS_MESSAGE =
  "You have successfully created an account. Please sign in.";

export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";

export const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";

export const SET_USER_DATA = "SET_USER_DATA";
